var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containerNode",style:({
    height: '100vh',
    width: '100vw',
    position: 'relative', // for absolutely positioned children
    overflow: 'hidden',
    touchAction: 'none', // Not supported in Safari :(
    msTouchAction: 'none',
    cursor: _vm.grabbing?'grabbing':'grab',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none'
  }),attrs:{"id":"mapbox"},on:{"mousewheel":_vm.onWheel,"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd,"touchmove":_vm.onTouchMove,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mousemove":_vm.onMouseMove,"dblclick":function($event){return _vm.$emit('dblclick')}}},[_c('div',{style:({
      display: 'inline-block', // size to content
      transform: _vm.transform,
      transformOrigin: '0 0 '
    })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }